// extracted by mini-css-extract-plugin
module.exports = {"main_color":"#009ccc","container":"UserAvatar-module--container--3coJz","no_image":"UserAvatar-module--no_image--3vrF4"};